import React, { useState } from 'react';
import { observer } from "mobx-react";
import { autorun } from 'mobx'
import { useHistory } from "react-router-dom";
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'

import LoadingSpinner from '../components/LoadingSpinner';
import {
  regionsStore
} from '../store/apiStores'

import './SelectLocation.css'


export default observer(function SelectRegion(props){

    let store = regionsStore;

    // updates as selections are made in ui:
    const [selectedRegion, setSelectedRegion] = useState(props.region || "");


    let regionChanged = (e) => {
      e.preventDefault();
      setSelectedRegion(e.target.value)
    }

    const history = useHistory();

    let changeRegion = ((e) => {
      e.preventDefault();
      if (props.changeRegionHandler) {
        props.changeRegionHandler(selectedRegion);
      }
      else {
        const rootUrl = props.rootUrl || '/tracking/region/'
        history.push(rootUrl
          + selectedRegion.replace(/\s+/g, '-').toLowerCase()
          + (window.location.search || ''))
      }
    })

    let wrapperClassName = `select-location-wrapper ${props.small ? 'small' : 'large'}`
    let formSize = props.small ? "sm" : null;
    let options = (store.data || []).map((s) => {
      return {
        value: s.region,
        text: s.region
      }
    })

    return (
      <div className={wrapperClassName}>
        <Form inline={true}>
          {props.header &&
            <div className="header d-none d-sm-block">{props.header}</div>
          }
          <Form.Group size={formSize} controlId="select-region-control">
            {(!store.data) ? (
              <LoadingSpinner />
            ) : (
              <Form.Control as="select" value={selectedRegion} onChange={regionChanged} custom>
                {props.unselectedRegionOption && (
                  <option value="">({props.unselectedRegionOption})</option>
                )}
                {options.map((o) => (
                  <option key={o.value} value={o.value}>{o.text}</option>
                ))}
              </Form.Control>
            )}
          </Form.Group>
          <Button size={formSize} variant="primary" onClick={changeRegion}>
            {props.changeRegionButtonText || 'Go'}
          </Button>
        </Form>
      </div>
    )
})
